export default "https://assets.egbcdn.net/assets/packs/_/images/landing-ladder/streamers/streamer-photo-35e91d07563f3edc87c169b4abde8e9d.svg";